module.exports = __webpack_public_path__ + "img/20200513_151448.a280528c.jpg";